/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Name } from './Name';
import {
    NameFromJSON,
    NameFromJSONTyped,
    NameToJSON,
    NameToJSONTyped,
} from './Name';

/**
 * 
 * @export
 * @interface ContactDetails
 */
export interface ContactDetails {
    /**
     * 
     * @type {Name}
     * @memberof ContactDetails
     */
    name: Name;
    /**
     * 
     * @type {string}
     * @memberof ContactDetails
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDetails
     */
    mobileNumber: string;
}

/**
 * Check if a given object implements the ContactDetails interface.
 */
export function instanceOfContactDetails(value: object): value is ContactDetails {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('mobileNumber' in value) || value['mobileNumber'] === undefined) return false;
    return true;
}

export function ContactDetailsFromJSON(json: any): ContactDetails {
    return ContactDetailsFromJSONTyped(json, false);
}

export function ContactDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'name': NameFromJSON(json['name']),
        'phoneNumber': json['phoneNumber'],
        'mobileNumber': json['mobileNumber'],
    };
}

export function ContactDetailsToJSON(json: any): ContactDetails {
    return ContactDetailsToJSONTyped(json, false);
}

export function ContactDetailsToJSONTyped(value?: ContactDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': NameToJSON(value['name']),
        'phoneNumber': value['phoneNumber'],
        'mobileNumber': value['mobileNumber'],
    };
}

